import PropTypes from "prop-types";
import React, { useContext } from "react";

import { StateContext } from "../../StateContext";
import Content from "../Content";
import FramedTitle from "../FramedTitle";
import Hero from "../Hero";
import heroNarrow from "../Home/images/pub-narrow.webp";
import hero from "../Home/images/pub.webp";
import Markdown from "../Markdown";
import Notice from "../Notice";

const VenueHome = ({ location }) => {
  const { contents } = useContext(StateContext);
  const notice = contents[`${location}Home`];
  const title = location.charAt(0).toUpperCase() + location.slice(1);

  return (
    <>
      <Hero src={hero} narrowSrc={heroNarrow} />
      <Content>
        <FramedTitle text={title} />
        <Notice title="Hi there!" frameStyle="brown">
          <Markdown>{notice}</Markdown>
        </Notice>
      </Content>
    </>
  );
};

VenueHome.propTypes = {
  location: PropTypes.string.isRequired,
};

export default VenueHome;
